import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const DEFAULT_CONTACT = {
  heading: 'Questions?',
  body: (
    <>
      Email us at <a href="mailto:hello@ainasuite.com">hello@ainasuite.com</a> and a human will reply within 2 business days.
    </>
  ),
};

function renderListItem(item) {
  if (typeof item === 'string') return item;
  return (
    <>
      <strong>{item.label}:</strong> {item.text}
    </>
  );
}

export default function LegalPage({ title, updated, intro, sections, contact }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [title]);

  const contactBlock = contact || DEFAULT_CONTACT;

  return (
    <article className="legal">
      <div className="legal__hero">
        <div className="container">
          <nav className="legal__crumbs" aria-label="breadcrumb">
            <Link to="/">Home</Link>
            <ChevronRight size={14} />
            <span>Legal</span>
            <ChevronRight size={14} />
            <span className="legal__crumbsCurrent">{title}</span>
          </nav>
          <h1 className="legal__title">{title}</h1>
          <p className="legal__updated">Last updated · {updated}</p>
          <p className="legal__intro">{intro}</p>
        </div>
      </div>

      <div className="container legal__body">
        <aside className="legal__toc">
          <div className="legal__tocLabel">On this page</div>
          <ul>
            {sections.map((s) => (
              <li key={s.id}>
                <a href={`#${s.id}`}>{s.heading}</a>
              </li>
            ))}
          </ul>
        </aside>

        <div className="legal__content">
          {sections.map((s) => (
            <section key={s.id} id={s.id} className="legal__section">
              <h2>{s.heading}</h2>

              {s.body && s.body.map((p, i) => <p key={i}>{p}</p>)}

              {s.list && (
                <ul className="legal__list">
                  {s.list.map((item, i) => (
                    <li key={i}>{renderListItem(item)}</li>
                  ))}
                </ul>
              )}

              {s.subsections && s.subsections.map((sub, idx) => (
                <div key={idx} className="legal__sub">
                  <h3>{sub.heading}</h3>
                  {sub.body && sub.body.map((p, i) => <p key={i}>{p}</p>)}
                  {sub.list && (
                    <ul className="legal__list">
                      {sub.list.map((item, i) => (
                        <li key={i}>{renderListItem(item)}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </section>
          ))}

          <div className="legal__contact">
            <h3>{contactBlock.heading}</h3>
            <p>{contactBlock.body}</p>
          </div>
        </div>
      </div>
    </article>
  );
}
